

















































































import VueOptions from '@utils/VueOptions'
import Carousel from '@ui/Carousel'
import CalendarService from '@services/CalendarService'
import { RRule } from 'rrule'

settings =
  name: "AudienceListingThumbnail"

  vue:
    props: ['audienceListing', 'activationPlan', 'actions', 'options']
    components: { Carousel }

    computed:
      isSameDay: ->
        return false
        # @audienceListing.local_start_day is @audienceListing.local_end_day
      featuredEventIds: ->
        return []
        # @options?.campaign?.featured_event_ids || []
      favoriteEventSetIds: ->
        return []
        # @options?.campaign?.favorite_event_set_ids || []
      recentlyPublishedEventIds: ->
        return []
        # @options?.campaign?.recently_published_event_ids || []

      hasFavoriteActions: -> @actions?.favoriteEventTrigger? and @actions?.unfavoriteEventTrigger?
      isRecommended: ->
        return false
        # @audienceListing?.event_set_id in @options?.campaign?.recommended_event_set_ids if @options?.campaign?.recommended_event_set_ids
      isFavorited: ->
        return false
        # @audienceListing?.event_set_id in @favoriteEventSetIds
      isStaffPick: ->
        return false
        # @audienceListing?.id in @featuredEventIds
      isRecentlyPublished: ->
        return false
        # @audienceListing?.id in @recentlyPublishedEventIds
      countApproved: ->
        0
      countDenied: ->
        0
      countComments: ->
        0

      cardImages: ->
        return @omnichannelPlaceholderImages if @isOmnichannel
        @audienceListing.images

      carouselOptions: ->
        opts =
          height: '200px'
          spaceBetweenSlides: '0px'
          perPage: 1
          loop: true
          navigationPrevLabel: '<span class="flex items-center justify-center -ml-5 w-8 h-8 text-white opacity-75 hover:opacity-100 custom-text-shadow"><i class="fas fa-chevron-left text-2xl"></i></span>'
          navigationNextLabel: '<span class="flex items-center justify-center -mr-5 w-8 h-8 text-white opacity-75 hover:opacity-100 custom-text-shadow"><i class="fas fa-chevron-right text-2xl"></i></span>'
          displayGallery: false
        opts

      location: ->
        @$options.filters.formatLocation @audienceListing

      listingDate: ->
        { calendar_dates, calendar_seasons: seasons } = @audienceListing
        return '-' unless calendar_dates.length
        { start: date, repeats, rrule: rruleString } = calendar_dates[0]

        if repeats and @activationPlan
          rrule = CalendarService.rruleFromString rruleString
          if rrule.freq in [RRule.YEARLY, RRule.MONTHLY]
            { start_date, end_date } = @activationPlan
            return @$options.filters.formatDateWindow start_date, end_date if start_date and end_date

        CalendarService.formatCalendarDate { date, repeats, rruleString, seasons }

      isOmnichannel: ->
        @activationPlan?.line_items_info?[0]?.item?.pricing_model is 'omnichannel'

      omnichannelPlaceholderImages: ->
        [
          'https://marketplace-live-assets.s3.us-west-1.amazonaws.com/spaces/online-community.png'
        ]

    methods:
      navigateToDetails: ->
        return false
        # routeName = 'EventFeedDetails'
        # routeName = 'CheckoutEventDetails' if @$route.name is 'CheckoutPage'
        # @$router.push { name: routeName, params: { eventId: @audienceListing.id } }
      navigateToInstanceDetails: (instanceId) ->
        return false
        # @$router.push({ name: 'EventFeedDetails', params: { eventId: instanceId } })

      hiFavoriteEventTrigger: -> @actions.favoriteEventTrigger @audienceListing
      hiUnfavoriteEventTrigger: -> @actions.unfavoriteEventTrigger @audienceListing


export default VueOptions.vue settings
